module.exports = __webpack_public_path__ + "img/home-banner-bigstock-gr.924ea5ae.jpg";